/**
 * localStorage that cannot take the page down with it.
 *
 * Reading `localStorage` is not a safe expression. Safari with "Block All
 * Cookies" on, and Chrome with third-party site data blocked in an iframe,
 * raise `SecurityError` from the *getter* — before `getItem` is ever called —
 * and iOS in-app browsers (WKWebView) hand out `null` when site data is
 * restricted, which makes the call a TypeError instead. So the property access
 * itself has to sit inside the try, not just the method call (Sentry
 * HU-BOL-WEB-2B, PR 1319).
 *
 * Everything this site keeps in Storage is a convenience, never a source of
 * truth, so the contract is: reads answer null when unavailable, writes are
 * silently dropped. A blocked browser then simply behaves like a first-time
 * visitor, which is a case the callers already handle.
 */
export function readStored(key) {
    try {
        // `localStorage` is read inside the try on purpose — see above.
        return window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
        return null;
    }
}

export function writeStored(key, value) {
    try {
        if (window.localStorage) {
            window.localStorage.setItem(key, value);
        }
    } catch (e) {
        // Private windows and full quotas. Not worth a crash for a dismissal flag.
    }
}
